import React, { Component } from 'react';

import Title from '../../components/Title';
import Conteudo from '../../Conteudo';

import ListaConsumoAgua from './ListaConsumoAgua';
import ListaConsumoAguaMineral from './ListaConsumoAguaMineral';

export default class extends Component {
  render() {
    return (<div>
        <Title value="Diego Rivera » Consumo" />
        <Conteudo>
          <ListaConsumoAguaMineral />
          <ListaConsumoAgua />
        </Conteudo>
    </div>);
  }
}


// WEBPACK FOOTER //
// ./src/modules/consumo/Index.js